export enum DeviceStatus {
  STOCKED = 'STOCKED',
  DELIVERED = 'DELIVERED',
  PENDING_RETURN = 'PENDING_RETURN',
  DECOMMISSIONED = 'DECOMMISSIONED',
  BROKEN = 'BROKEN',
  MISSING = 'MISSING',
}
